import { Injectable } from '@angular/core';
import { AngularFirestore, CollectionReference } from '@angular/fire/compat/firestore';
import { User } from '@app/@shared/models/user.model';
import { Logger } from '../logger.service';
import { Timestamp, serverTimestamp } from 'firebase/firestore';

const log = new Logger('user-service');

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private collection: CollectionReference<User>;

  constructor(private firestore: AngularFirestore) {
    this.collection = this.firestore.collection<User>('users').ref;
  }

  // Obtener todos los elementos
  async getAll(): Promise<User[]> {
    const snap = await this.collection.get();
    const data = snap.docs.map((o) => {
      return { uid: o.id, ...o.data() };
    });
    return data;
  }

  // Obtener un elemento por ID
  async getById(uid: string): Promise<User | null> {
    const snap = await this.collection.doc(uid).get();
    if (snap.exists) {
      const data = { uid: snap.id, ...snap.data() } as User;
      return data;
    } else {
      return null;
    }
  }

  // Crear un nuevo elemento
  async create(item: User): Promise<{
    success: boolean;
    message: string;
  }> {
    try {
      const exists = await this.getById(item.uid!);
      if (!exists) {
        this.collection;
        await this.collection.doc(item.uid!).set(item);
        return {
          success: true,
          message: 'Usuario agregado correctamente',
        };
      } else {
        return {
          success: false,
          message: 'Usuario ya existente',
        };
      }
    } catch (error: any) {
      return {
        success: false,
        message: error.message,
      };
    }
  }

  // Actualizar un elemento
  async update(uid: string, item: Partial<User>): Promise<void> {
    await this.collection.doc(uid).update(item);
  }

  // Eliminar un elemento
  async delete(uid: string): Promise<void> {
    try {
      await this.collection.doc(uid).delete();
    } catch (error) {
      log.error(error);
    }
  }

  async updateLoginAt(user: User): Promise<User> {
    const toUpdate: Pick<User, 'actualLogin' | 'lastLogin'> = {
      lastLogin: user.actualLogin ?? (serverTimestamp() as any),
      actualLogin: serverTimestamp() as any,
    };

    try {
      await this.collection.doc(user.uid!).update(toUpdate);
    } catch (error) {
      log.error(error);
    }

    return {
      ...user,
      lastLogin: user.actualLogin ?? Timestamp.now(),
      actualLogin: Timestamp.now(),
    };
  }
}
